import './_autocomplete-search-blog-page-hits.scss';
import component from './autocomplete-search-blog-page-hits';

export default component;
